<script>
  import Image from '$lib/Image.svelte'
  export let items = []
</script>

<section class="items">
  {#each items as item}
    {@const { title, icon } = item}
    <div class="item">
      <div class="wrap">
        {#if icon}
          <div class="icon">
            <Image
              src={icon.src}
              alt={icon.alt || ''}
              width={icon.width}
              height={icon.height} />
          </div>
        {/if}
        <div class="main">
          <h2 class="title">{title}</h2>
          <div class="body">
            <slot {item} />
          </div>
        </div>
      </div>
    </div>
  {/each}
</section>

<style>
  .items {
    display: grid;
    gap: 1.5rem 2rem;
    text-wrap: balance;
  }

  .item {
    container-type: inline-size;
    gap: 1rem;
  }

  .wrap {
    display: flex;
    gap: 1rem;
  }

  .icon {
    width: 4.5rem;
    flex: 0 0 auto;
    user-select: none;
    border-radius: var(--border-radius-md);
    overflow: hidden;
  }

  .main {
    margin-top: 0.25em;
  }

  .body {
    color: rgb(var(--rgb-muted));
  }

  .title {
    font-family: var(--heading-font-family);
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1.15;
    word-spacing: -0.05em;
    letter-spacing: -0.02em;
  }

  @container (min-width: 18rem) {
    .wrap {
      gap: 1.5rem;
    }

    .icon {
      width: 5.5rem;
    }
  }

  @media (min-width: 900px) {
    @container (min-width: 22rem) {
      .wrap {
        gap: 1.75rem;
      }

      .icon {
        width: 7rem;
      }

      .title {
        font-size: 1.6rem;
        line-height: 1.1;
      }

      .body {
        font-size: 1.125rem;
        margin-top: 0.25rem;
        max-width: 16rem;
      }
    }
  }

  @media (min-width: 900px) {
    .items {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
</style>
